/* eslint-disable */

import { motion } from "framer-motion";

import { useEffect, useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import { useSwipeable } from "react-swipeable";
import { Color, QuestionState, Size } from "../../../logic/enums.ts";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element.js";

import { fetchGraphQL } from "../../../services/api-raindrop.js";
import StreakDisplay from "../../../ui-components/streak-display/streak-display.tsx";
import QuizAnswerButton from "../../../ui-components/quiz-answer-button/quiz-answer-button.tsx";

import { useNavigate } from "react-router-dom";

import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropSparkleCurtain from "../../../ui-components/raindrop-sparkle-curtain/raindrop-sparkle-curtain.tsx";
import RaindropProgressBar from "../../../ui-components/raindrop-progress-bar/raindrop-progress-bar.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";

const COLOR_INCORRECT__BORDER =
  "border-color-border-red dark:border-color-dark-border-red";

const COLOR_CORRECT__BORDER =
  "border-color-border-green dark:border-color-dark-border-green";

enum GameState {
  MainMenu = "main-menu",
  Playing = "playing",
  StreakIncrement = "streak-increment",
  Summary = "summary",
}

const ComponentSharecard = ({
  date = new Date(),
  points = -1,
  numberOfQuestions = 10,
  streakCount = 1,
  categoryName = null,
}) => {
  const percentage = Math.floor((100 * points) / numberOfQuestions);
  const dateNumber = date.getDate();
  const dateString = date.toLocaleString("default", { month: "short" });

  const dateStr = "" + dateNumber + " " + dateString;

  let tailwindCardBackground =
    "bg-gradient-to-br from-color-raindrop-primary to-pink-900";

  const TopBar = () => {
    return (
      <div className="flex w-full flex-row gap-8 justify-center items-center m-2 text-white text-opacity-60">
        <div className="flex flex-row w-full items-center justify-center gap-2">
          <i className="fas fa-calendar-day text-lg" />
          <h1 className="whitespace-nowrap font-black">{dateStr}</h1>
        </div>
        <div className="flex flex-row w-full gap-2 items-center justify-center ">
          <i className="fas fa-fire text-lg" />
          <h1 className="font-black">{streakCount}</h1>
        </div>
      </div>
    );
  };

  const Score = () => {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="flex flex-col gap-2 w-full h-full justify-center items-center">
          <div className="flex flex-row  items-baseline text-color-dark-text-primary">
            <div className="font-black  text-7xl">{percentage}</div>
            <div className="font-black text-3xl">%</div>
          </div>
        </div>
      </div>
    );
  };

  const Topic = () => {
    return (
      <div className="flex items-center justify-center bg-black bg-opacity-20 p-2 rounded-lg text-center m-2 text-md">
        <h1 className="font-bold text-center text-color-dark-text-primary">
          {categoryName}
        </h1>
      </div>
    );
  };

  const DarkHumour = () => {
    return (
      <div className="flex w-full bg-black  text-center p-2 text-xs">
        <div className="flex flex-row  items-center  w-full justify-center gap-2">
          <i className="fas fa-skull " />
          <h1 className="font-bold text-center ">Dreadful</h1>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col p-6 bg-color-dark-background-secondary gap-3 w-[300px] h-[400px] relative border border-color-dark-border-primary">
      <div
        className={`flex flex-col  w-[250px] h-[250px] aspect-square  rounded-lg ${tailwindCardBackground}   border-8 border-white  `}
      >
        <TopBar />
        <Score />
        <Topic />

        {/* <DarkHumour /> */}
      </div>
      <div className="flex h-full w-full flex-col items-center gap-2">
        <RaindropTitle size={Size.Small} style={ButtonStyle.Primary} />
        <h1 className="font-black text-4xl text-color-dark-text-primary">
          Daily Quiz
        </h1>
        <p className="flex gap-2 items-center text-xs font-bold text-color-dark-text-secondary">
          <i className="fas fa-link" />
          app.theraindropcompany.com
        </p>
      </div>
    </div>
  );
};

const Swipeable = ({
  onSwipedLeft = (eventData) => {},
  onSwipedRight = (eventData) => {},
  onSwipedUp = (eventData) => {},
  onSwiping = (eventData) => {},
  children,
}) => {
  const handlers = useSwipeable({
    onSwipedLeft: onSwipedLeft,
    onSwipedRight: onSwipedRight,
    onSwipedUp: onSwipedUp,
    onSwiping: onSwiping,
    trackMouse: true,
  });

  return (
    <div className="flex flex-col w-full h-full" {...handlers}>
      {children}
    </div>
  );
};

const SubcomponentQuestionDot = ({ questionData }) => {
  let backgroundClass = "dark:bg-color-dark-background-secondary bg-slate-300";
  let sizeTailwind = "w-2 h-2";

  if (questionData.state === QuestionState.Correct) {
    backgroundClass = "bg-color-border-green";
    sizeTailwind = "w-3 h-3";
  }
  if (questionData.state === QuestionState.Incorrect) {
    backgroundClass = "bg-color-border-red";
  }
  return (
    <div className="flex flex-col items-center justify-center w-3 h-3 ">
      <div
        className={`${sizeTailwind} rounded-full ${backgroundClass} transition-all `}
      />
    </div>
  );
};

const ComponentQuestionCount = ({ questionDataList }) => {
  return (
    <div className="flex flex-row gap-2 items-center  justify-center w-full flex-wrap-reverse px-10 relative">
      {questionDataList.map((questionData, index) => (
        <SubcomponentQuestionDot key={index} questionData={questionData} />
      ))}
    </div>
  );
};

const QuestionImageCard = ({
  currentSrc = "",
  questionState = QuestionState.NotAnswered,
  onLoad = () => {},
  onError = () => {},
}) => {
  let borderClass =
    "border-8 border-color-text-secondary dark:border-color-dark-border-primary";

  if (questionState === QuestionState.Correct) {
    borderClass = COLOR_CORRECT__BORDER;
  }
  if (questionState === QuestionState.Incorrect) {
    borderClass = COLOR_INCORRECT__BORDER;
  }

  return (
    <img
      alt=""
      src={currentSrc}
      className={`rounded-2xl border-8 ${borderClass} h-[300px]`}
      onLoad={onLoad}
      onError={onError}
    />
  );
};

const QuestionCardStack = ({
  questionDataList,
  currentQuestionIndex,
  setAllImagesLoaded = (x) => {},
}) => {
  const [numLoaded, setNumLoaded] = useState(0);

  const handleImageLoad = () => {
    setNumLoaded((prev) => prev + 1);
  };

  useEffect(() => {
    if (numLoaded === questionDataList.length) {
      setAllImagesLoaded(true);
    }
  }, [numLoaded]);

  return (
    <div className="flex flex-col relative justify-center ">
      {questionDataList.map((questionData, index) => {
        const isPrevious = index < currentQuestionIndex;
        const isVisible = index === currentQuestionIndex;

        return (
          <motion.div
            key={index}
            id={`question-${index}`}
            className={`flex ${
              index == 0 ? "relative" : "absolute"
            } w-full  items-center justify-center`}
            animate={{
              opacity: isVisible ? 1 : 0,
              translateY: isVisible ? 0 : isPrevious ? -50 : 50,
              transition: {
                duration: 0.2,
                ease: "linear",
                delay: isVisible ? 0.2 : 0.2,
              },
            }}
          >
            <QuestionImageCard
              currentSrc={questionData.src}
              questionState={questionData.state}
              onLoad={handleImageLoad}
            />
          </motion.div>
        );
      })}
    </div>
  );
};

const ComponentAnswers = ({
  onAnswer = (x) => {},
  currentQuestion,
  optionA,
  optionB,
}) => {
  return (
    <div className="flex flex-col gap-4 items-center">
      <div className={`flex gap-4 w-full  justify-center  `}>
        <QuizAnswerButton
          onClick={() => onAnswer(optionA)}
          title={optionA}
          isCorrectAnswer={currentQuestion.answer === optionA}
        />
        <QuizAnswerButton
          onClick={() => onAnswer(optionB)}
          title={optionB}
          isCorrectAnswer={currentQuestion.answer === optionB}
        />
      </div>
      <div className="flex flex-col w-full justify-center items-center gap-4">
        <QuizAnswerButton
          onClick={() => onAnswer("neither")}
          title={"Neither"}
          isThin={true}
          isCorrectAnswer={
            currentQuestion.answer !== optionA &&
            currentQuestion.answer !== optionB
          }
        />
      </div>
    </div>
  );
};

const DarkHumourLine = ({
  isDarkHumour = true,
  questionState = QuestionState.NotAnswered,
}) => {
  if (!isDarkHumour) {
    return null;
  }

  const [text, setText] = useState("");

  const meanThings = [
    "No wonder you're alone",
    "The trash misses you",
    "Your bullies wish they bullied you harder",
    "Your mother never loved you",
    "Small D energy",
  ];

  useEffect(() => {
    if (questionState === QuestionState.Incorrect) {
      setText(meanThings[Math.floor(Math.random() * meanThings.length)]);
    } else {
      setText("");
    }
  }, [questionState]);

  if (!isDarkHumour || questionState !== QuestionState.Incorrect) {
    return <div className="h-12" />;
  }

  return (
    <RaindropMotionFadeUp duration={0.6} delay={0}>
      <div className="flex flex- w-full items-center justify-center h-12 ">
        {isDarkHumour && text && (
          <div className="flex flex-row gap-2 items-center font-black text-color-dark-text-secondary">
            <i className="fas fa-skull text-2xl " />
            <h4 className="">{text}</h4>
          </div>
        )}
      </div>
    </RaindropMotionFadeUp>
  );
};

const MainGame = ({
  allData,
  userCurrent,
  numberOfQuestions = 10,
  setUserCurrent = (s) => {},
  isDarkHumour = false,
  setGameState = (s) => {},
  secondsElapsed = -1,
  setSecondsElapsed = (s) => {},
  setCurrentScore = (s) => {},
  setStreakCount = (s) => {},
}) => {
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [questionDataList, setQuestionDataList] = useState(allData);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const currentQuestion =
    questionDataList && questionDataList[currentQuestionIndex];

  const isPaused = false;

  const onEndQuiz = () => {
    setIsLoading(true);
    const numCorrectAnswers = questionDataList.filter(
      (item) => item.state === QuestionState.Correct
    ).length;

    if (userCurrent === null) {
      setStreakCount(1);
      setGameState(GameState.StreakIncrement);
      return;
    }

    fetchGraphQL(`
      mutation {
        incrementQuizStreak (
          totalQuestions: ${numberOfQuestions}
          correctAnswers: ${numCorrectAnswers}
        ) {
          lastQuizDate
          longestStreak
          currentStreak
          hasCompletedQuizToday
        }
      }
      `)
      .then((response) => {
        // Handle errors
        if (response.errors) {
          console.error("Error incrementing quiz streak:", response.errors);
          return;
        }

        setUserCurrent((prev) => {
          return {
            ...prev,
            account: {
              ...prev.account,
              streak: response.data.incrementQuizStreak,
            },
          };
        });
        setStreakCount(response.data.incrementQuizStreak.currentStreak);
        setGameState(GameState.StreakIncrement);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPaused) {
        return;
      }
      setSecondsElapsed((prevSecondsElapsed) => prevSecondsElapsed + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsElapsed]);

  // Move to summary if finished.
  useEffect(() => {
    if (questionDataList === null) {
      return;
    }
    if (currentQuestionIndex === questionDataList.length) {
      onEndQuiz();
      return;
    }
  }, [currentQuestionIndex]);

  const onAnswer = (providedAnswer) => {
    if (currentQuestion === null) {
      return;
    }
    if (currentQuestion.state !== QuestionState.NotAnswered) {
      return;
    }
    const shouldBeNeither =
      currentQuestion.optionA !== currentQuestion.answer &&
      currentQuestion.optionB !== currentQuestion.answer;

    let isCorrect = false;

    if (providedAnswer === currentQuestion.answer) {
      isCorrect = true;
    }
    if (shouldBeNeither && providedAnswer === "neither") {
      isCorrect = true;
    }

    if (isCorrect) {
      setCurrentScore((prevValue) => prevValue + 1);
    }

    setQuestionDataList((prevValue) => {
      if (prevValue == null) {
        return;
      }
      return prevValue.map((item, index) => {
        if (index === currentQuestionIndex) {
          return {
            ...item,
            state: isCorrect ? QuestionState.Correct : QuestionState.Incorrect,
          };
        }
        return item;
      });
    });
    setTimeout(() => {
      setCurrentQuestionIndex((prevValue) => prevValue + 1);
    }, 150);
  };

  // Add hotkeys - START
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "d") {
      onAnswer(currentQuestion.optionA);
    }
    if (event.key === "j") {
      onAnswer(currentQuestion.optionB);
    }
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);
  // Add hotkeys - END

  const onSwipedLeft = () => {
    onAnswer(currentQuestion.optionA);
  };

  const onSwipedRight = () => {
    onAnswer(currentQuestion.optionB);
  };

  const onSwipedUp = () => {
    onAnswer("neither");
  };

  if (!questionDataList || !currentQuestion || isLoading) {
    return <RaindropLoadingElement isShnoodle={true} />;
  }

  return (
    <div className="flex flex-col w-full ">
      {!allImagesLoaded && (
        <div className="flex flex-col gap-4 absolute w-full h-full items-center justify-center">
          <RaindropLoadingElement isShnoodle={true} />
        </div>
      )}
      <div
        className={`${
          allImagesLoaded ? "opacity-100" : "opacity-0 translate-y-10"
        } delay-700 duration-200 transition-all`}
      >
        <Swipeable
          onSwipedLeft={() => onSwipedLeft()}
          onSwipedRight={(e) => onSwipedRight()}
          onSwipedUp={(e) => onSwipedUp()}
        >
          <div
            className={`flex flex-col gap-8 w-full h-full  transition-all duration-300 relative `}
          >
            {/* <ComponentQuestionCount questionDataList={questionDataList} /> */}

            <FlexRow className="px-10">
              <RaindropProgressBar
                proportion={currentQuestionIndex / questionDataList.length}
              />
            </FlexRow>

            <QuestionCardStack
              questionDataList={questionDataList}
              currentQuestionIndex={currentQuestionIndex}
              setAllImagesLoaded={setAllImagesLoaded}
            />

            <DarkHumourLine
              questionState={currentQuestion.state}
              isDarkHumour={isDarkHumour}
            />

            <ComponentAnswers
              onAnswer={onAnswer}
              currentQuestion={currentQuestion}
              optionA={currentQuestion.optionA}
              optionB={currentQuestion.optionB}
            />
          </div>
        </Swipeable>
      </div>
    </div>
  );
};

const MainMenu = ({ onBegin = () => {}, setIsDarkHumour = (x) => {} }) => {
  return (
    <div className="flex flex-col gap-4 w-full h-full items-center justify-center">
      <RaindropMotionFadeUp>
        <div className="flex flex-col gap-3 items-center ">
          <RaindropTitle size={Size.Medium} />
          <h1 className="text-6xl md:text-7xl font-black text-color-raindrop-primary">
            Daily Quiz
          </h1>
        </div>
      </RaindropMotionFadeUp>

      <div className="flex flex-col gap-4 w-full max-w-md h-80 justify-center">
        <RaindropMotionFadeUp delay={0.3}>
          <RaindropButton
            title={"Play"}
            onClick={() => {
              setIsDarkHumour(false);
              onBegin();
            }}
            style={ButtonStyle.Primary}
            size={Size.Large}
            isFluid={true}
          />
        </RaindropMotionFadeUp>
        {/* <RaindropMotionFadeUp delay={0.4}>
          <RaindropButton
            title={"Play with dark humour"}
            onClick={() => {
              setIsDarkHumour(true);
              onBegin();
            }}
            icon="fa-skull"
            size={Size.Large}
            isFluid={true}
          />
        </RaindropMotionFadeUp> */}
      </div>
    </div>
  );
};

const MainStreakIncrement = ({ streakCount = 1, setGameState }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      setGameState(GameState.Summary);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="flex flex-col gap-6 w-full h-full items-center justify-center ">
      <RaindropMotionFadeUp>
        <StreakDisplay streak={streakCount} size={Size.Huge} />
      </RaindropMotionFadeUp>

      <RaindropMotionFadeUp delay={0.5}>
        <div className="flex flex-col gap-4 items-center">
          <h1 className="font-black text-5xl">Day Streak</h1>
        </div>
      </RaindropMotionFadeUp>
    </div>
  );
};

const MainSummary = ({
  score = -1,
  setShareComponent = (x) => {},
  streakCount = 1,
  numberOfQuestions = -1,
  categoryName = null,
}) => {
  const [isCopied, setIsCopied] = useState(true);

  const shareComponent = (
    <ComponentSharecard
      date={new Date()}
      points={score}
      streakCount={streakCount}
      numberOfQuestions={numberOfQuestions}
      categoryName={categoryName}
    />
  );
  const onShare = () => {
    setShareComponent(shareComponent);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsCopied(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [isCopied]);

  return (
    <div className="flex flex-col h-full  w-full gap-12 items-center overflow-y-scroll no-scrollbar">
      <RaindropSparkleCurtain />
      <RaindropMotionFadeUp className="flex-col gap-10 h-full ">
        <div className="flex flex-col h-full gap-4 items-center justify-center">
          {shareComponent}

          <div className="flex flex-row gap-2">
            <RaindropButton
              title={"Share"}
              icon="fa-share-alt"
              onClick={onShare}
              size={Size.Large}
              style={ButtonStyle.Primary}
            />
          </div>
        </div>
      </RaindropMotionFadeUp>
    </div>
  );
};

const RaindropBombshell = ({
  userCurrent,
  setUserCurrent = (s) => {},
  setShareComponent,
  setIsFocusedOnCenter = (x) => {},
}) => {
  const hasCompletedQuizToday =
    userCurrent?.account?.streak?.hasCompletedQuizToday || false;

  const navigate = useNavigate();

  const [gameState, setGameState] = useState(GameState.MainMenu);

  const [currentScore, setCurrentScore] = useState(0);
  const [secondsElapsed, setSecondsElapsed] = useState(0);

  const [isDarkHumour, setIsDarkHumour] = useState(false);

  const [streakCount, setStreakCount] = useState(
    userCurrent?.account?.streak?.currentStreak || 0
  );

  const [dbQuestions, setDBQuestions] = useState(null);
  const [quizAccountAttempt, setQuizAccountAttempt] = useState(null);

  const categoryName = dbQuestions && dbQuestions[0].category?.name;

  const onBegin = () => {
    setCurrentScore(0);
    setSecondsElapsed(0);
    setGameState(GameState.Playing);
  };

  // Darken the background
  useEffect(() => {
    setIsFocusedOnCenter(true);
    return () => {
      setIsFocusedOnCenter(false);
    };
  }, []);

  // Fetch the questions from the server
  useEffect(() => {
    fetchGraphQL(`
      query {
        quizAccountAttempt {
          id
          totalQuestions
          correctAnswers
        }
        dailyQuizQuestions {
          id
          answer
          image {
            presignedUrl
          }
          optionA
          optionB
          category {
            name
          }       
        }
      }
    `).then((result) => {
      if (result.errors) {
        console.error("Error fetching daily quiz questions:", result.errors);
        return;
      }

      const newDBQuestions = result.data.dailyQuizQuestions.map((item) => {
        return {
          answer: item.answer,
          src: item.image.presignedUrl,
          optionA: item.optionA,
          optionB: item.optionB,
          state: QuestionState.NotAnswered,
          category: item.category,
        };
      });
      setDBQuestions(newDBQuestions);
      setQuizAccountAttempt(result.data.quizAccountAttempt);
      if (result.data.quizAccountAttempt) {
        setCurrentScore(result.data.quizAccountAttempt.correctAnswers || 0);
        // setGameState(GameState.Summary);  TODO: Bring this back.
      }
    });
  }, []);

  return (
    <div className="flex flex-col w-full h-full items-center px-4">
      <div className="flex flex-col h-full w-full max-w-lg overflow-y-scroll no-scrollbar py-4 gap-2">
        <RaindropBackButtonPanel />

        <div className="flex flex-col h-full items-center justify-center ">
          {gameState === GameState.MainMenu && (
            <MainMenu onBegin={onBegin} setIsDarkHumour={setIsDarkHumour} />
          )}

          {gameState === GameState.Playing && (
            <MainGame
              userCurrent={userCurrent}
              setUserCurrent={setUserCurrent}
              allData={dbQuestions}
              setGameState={setGameState}
              secondsElapsed={secondsElapsed}
              setSecondsElapsed={setSecondsElapsed}
              isDarkHumour={isDarkHumour}
              setCurrentScore={setCurrentScore}
              setStreakCount={setStreakCount}
              numberOfQuestions={dbQuestions?.length}
            />
          )}

          {gameState === GameState.StreakIncrement && (
            <MainStreakIncrement
              streakCount={streakCount}
              setGameState={setGameState}
            />
          )}

          {gameState === GameState.Summary && (
            <MainSummary
              score={currentScore}
              streakCount={streakCount}
              setShareComponent={setShareComponent}
              numberOfQuestions={dbQuestions?.length}
              categoryName={dbQuestions[0].category?.name}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RaindropBombshell;
